import React, {useEffect} from 'react';
import {Divider} from '@wix/wix-ui-tpa/cssVars';
import {classes} from './CustomerInputSection.st.css';
import {useBooleanStyleForAnyBreakpoint} from '../../../../../common/useBooleanStyleForAnyBreakpoint';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {Coupon} from '../../../../../common/components/Coupon/Coupon';
import stylesParams from '../../../stylesParams';
import settingsParams from '../../../settingsParams';
import {BuyerNote} from '../../../../../common/components/BuyerNote/BuyerNote';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';
import {SlotPlaceHolder} from '../../../../../common/components/SlotPlaceHolder/SlotPlaceHolder';
import {SlotsMap} from '../../../../../common/constants';
import {useSlotPlaceholder} from '@wix/widget-plugins-ooi';

export enum CustomerInputSectionDataHooks {
  root = 'CustomerInputSectionDataHooks.root',
  divider = 'CustomerInputSectionDataHooks.divider',
}

export const CustomerInputSection = () => {
  const {sideCartElementsVisibilityInCss, reportPromoCodePresented, reportBuyerNotePresented} =
    useControllerProps().cartStore;
  const {getBooleanStyle} = useBooleanStyleForAnyBreakpoint();
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const [, isEmpty] = useSlotPlaceholder(SlotsMap.SideCartCustomerInputAfter1);
  const shouldShowCustomerInputAfter1Slot = !isEmpty;

  const showPromoCodeBySettings = getBooleanStyle(
    stylesParams.CUSTOMER_INPUTS_PROMO_CODE_VISIBILITY,
    sideCartElementsVisibilityInCss
  );

  const showBuyerNoteBySettings = getBooleanStyle(
    stylesParams.CUSTOMER_INPUTS_NOTE_VISIBILITY,
    sideCartElementsVisibilityInCss
  );

  const shouldRenderCoupon = showPromoCodeBySettings;
  const shouldRenderBuyerNote = showBuyerNoteBySettings;
  const shouldRenderSection = shouldRenderCoupon || shouldRenderBuyerNote || shouldShowCustomerInputAfter1Slot;
  const shouldApplyResponsiveVisibility = sideCartElementsVisibilityInCss && !shouldShowCustomerInputAfter1Slot;

  useEffect(() => {
    reportPromoCodePresented(shouldRenderCoupon);
    reportBuyerNotePresented(shouldRenderBuyerNote);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRenderCoupon, shouldRenderBuyerNote]);

  return shouldRenderSection ? (
    <div
      data-hook={CustomerInputSectionDataHooks.root}
      className={shouldApplyResponsiveVisibility ? classes.rootResponsiveVisibility : undefined}>
      <Divider className={classes.divider} data-hook={CustomerInputSectionDataHooks.divider} />
      <div className={classes.linksWrapper}>
        {shouldRenderCoupon && (
          <Coupon
            textButtonSettingKey={settingsParams.SIDE_CART_ADD_PROMO_CODE_LINK}
            placeholderTranslationKey={getSettingsWithDefaults(settingsParams.SIDE_CART_PROMO_CODE_INPUT_PLACEHOLDER)}
            applyButtonTranslationKey={'sideCart.couponApplyButton.label'}
          />
        )}
        {shouldRenderBuyerNote && (
          <BuyerNote
            buttonCaptionSettingKey={settingsParams.SIDE_CART_ADD_NOTE_LINK}
            buttonPlaceholderSettingKey={settingsParams.SIDE_CART_INSTRUCTIONS_TEXT}
          />
        )}
        {shouldShowCustomerInputAfter1Slot && <SlotPlaceHolder slotId={SlotsMap.SideCartCustomerInputAfter1} />}
      </div>
    </div>
  ) : null;
};
